export const API_URL = process.env.REACT_APP_BACKEND_API_URL || 'http://localhost:3001/api';